import React from "react";
import "./navbar.scss";
import { Link, useHistory, useLocation } from "react-router-dom";

const Navbar = ({ setIsAuthenticated, setSessionExpired }) => {
  const history = useHistory();
  const location = useLocation();

  const handleLogout = () => {
    // Clear all session-related storage
    localStorage.removeItem("token");
    localStorage.removeItem("hasVisited");
    localStorage.removeItem("sessionActive");

    // Reset auth state
    setIsAuthenticated(false);
    setSessionExpired(false);

    // Redirect to login
    history.push("/");
  };

  // ✅ Show Navbar only on "/dashboard"
  if (location.pathname !== "/dashboard") {
    return null;
  }

  return (
    <div className="newbar">
      <div className="custom-container">
        <div className="navbar">
          <Link to="/dashboard">
            <img src="\assets\logo.svg" alt="Logo" />
          </Link>
          <button onClick={handleLogout}>Log Out</button>
        </div>
      </div>
    </div>
  );
};

export default Navbar;